<template>
    <section class="free-order section">
        <div class="container">
            <img class="free-order__img lazy" data-src="/assets/img/index/free-order-1.png" alt="Промо фото">
            <div class="free-order__inner">
                <h2 class="title">Выезжаем на бесплатный замер</h2>
                <p class="free-order__text">
                    Услуга замера предоставляется бесплатно. Мастера привозят с собой образцы материалов, чтобы на месте
                    можно было ознакомиться с их ассортиментом.
                </p>
                <button class="btn" type="button" @click="openForm">Заказать замер</button>
            </div>
            <img class="free-order__img lazy" data-src="/assets/img/index/free-order-2.png" alt="Промо фото">
        </div>
    </section>
</template>

<script>
import freeOrderForm from "./modals/free-order-form";

export default {
    name: 'freeOrder',
    components: {freeOrderForm},
    methods: {
        openForm() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setFreeOrderFormStatus', true);
            document.body.classList.add('_no-scroll');
        }
    },
}
</script>
